import React, { useState, useEffect } from "react";
import s from "./Stock.module.css";

//utilities
import { Currency } from "../../../helpers/currencyConvert";
import Pager from "../../Shared/Pagination/Pagination";
import exportToExcel from "../../../helpers/exportExcel";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import gamesService from "../../../api/games/GamesService";
import couponsService from "../../../api/delivery/couponsService";
import reportService from "../../../api/reports/reportsServices";
import { currencyFormat } from "../../../helpers/currency";

import {
  Alert,
  Button,
  CircularProgress,
  Grid,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalPrintshopRoundedIcon from "@mui/icons-material/LocalPrintshopRounded";
import DescriptionIcon from "@mui/icons-material/Description";
import FiltersStock from "./filters";
import { TableStockPrePrinted, TableStockInstantaneous } from "./tables";
import printTable from "../../../helpers/imprimir";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
  cursor: "pointer",
};

export const Stock = () => {
  const [logo, setLogo] = useState("");
  const { currentLogo } = useSelector((state) => state.local);
  const [printing, setPrinting] = useState(false);
  const [completeReport, setCompleteReport] = useState([]);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { textColor } = useSelector((state) => state.local);
  const { activeOrganization } = useSelector((state) => state.gamma);

  const [filters, setFilters] = useState({
    type: 0,
    gameId: null,
    raffleNumber: null,
    serie: null,
  });
  const [newFilters, setNewFilters] = useState({
    type: 0,
    gameId: null,
    raffleNumber: null,
    serie: null,
  });
  const [openError, setOpenError] = useState(false);
  const [noResult, setNoResult] = useState(false);

  const [loadingFilters, setLoadingFilters] = useState(false);
  const [games, setGames] = useState([]);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "nroCouponTo",
  });
  const [dateType, setDateType] = useState(0);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [searching, setSearching] = useState(0);
  const [totalResults, setTotalResults] = useState(0);

  const { formatCurrency } = currencyFormat();

  //Paginado
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pageCustom, setPageCustom] = useState(1);

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  const handleExport = () => {
    //let game = items[0].game.name;
    let excelData = [];
    const itemExcel1 = {};
    let today = new Date();
    let game = items[0]?.game?.name;
    excelData.push(itemExcel1);
    completeReport.map((item) => {
      const itemExcel = {};
      itemExcel[t("modality")] = item?.raffle?.serie || "-";
      itemExcel[t("deliveryNote")] = item?.deliveryNoteNumber || "-";
      itemExcel[t("value")] = formatCurrency(item?.raffle?.price) || "-";
      itemExcel[t("comition")] =
        `${formatCurrency(item?.raffle?.percentage) || 0} %`;
      itemExcel[t("Coupon_From")] = item?.nroCouponFrom || "-";
      itemExcel[t("Coupon_Until")] = item?.nroCouponTo || "-";
      itemExcel[t("quantity")] =
        item?.nroCouponTo - item?.nroCouponFrom + 1 || "-";
      itemExcel[t("movement")] = item?.deliveryNoteInputId
        ? t("income")
        : t("discharge");
      excelData.push(itemExcel);
    });
    const typeName =
      filters.type === 0
        ? t("all")
        : filters.type === 1
          ? t("preprinted")
          : t("instant");
    exportToExcel(
      excelData,
      `${t("queryStock")} ${typeName} - ${game} ${today.toISOString()}`,
    );
  };

  const handleSearch = () => {
    setNewFilters(filters);
    setPage(1);
    setSearching((prev) => prev + 1);
  };

  const handleCleanFilters = () => {
    setFilters({
      type: 0,
      gameId: null,
      raffleNumber: null,
      serie: null,
    });
    setNewFilters({
      type: 0,
      gameId: null,
      raffleNumber: null,
      serie: null,
    });
    setTotalResults(0);
    setTotalPages(1);
    setPage(1);
    setItems([]);
    setSearching(0);
  };

  const handleCleanTable = () => {
    setItems([]);
    setPage(1);
    setTotalPages(1);
  };

  const getStockData = () => {
    setLoading(true);
    reportService
      .getStock(page, pageSize, sort, newFilters)
      .then((res) => {
        if (res?.content?.length === 0) {
          setNoResult(true);
        }
        setItems(res.content);
        setTotalPages(res.totalPages);
        setTotalResults(res.totalElements);
        setLoading(false);
      })
      .catch(() => {
        setOpenError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLogo(currentLogo?.imgBase64);
  }, [currentLogo]);

  useEffect(() => {
    setLoadingFilters(true);
    gamesService
      .getAllGames()
      .then((res) => {
        setGames(res.content);
      })
      .then(() => setLoadingFilters(false));
  }, []);

  useEffect(() => {
    if (newFilters?.type !== 0) {
      getStockData();
    }
  }, [page, pageSize, sort, searching]);

  useEffect(() => {
    if (newFilters?.type !== 0) {
      reportService
        .getAllStock(sort, filters)
        .then((res) => {
          setCompleteReport(res);
        })
        .catch(() => {
          setOpenError(true);
        });
    }
  }, [sort, searching]);

  useEffect(() => {
    if (printing === true) {
      printTable(document.getElementById("stock-table"));
    }
    setPrinting(false);
  }, [printing]);

  return (
    <Grid container className={s.container}>
      <Grid item xs={12} className={s.header}>
        <Grid item container xs={12} className={s.titleContainer}>
          <Grid
            item
            xs={11}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Inventory2Icon
              sx={{ fontSize: "2rem", color: "primary.main", mr: 2 }}
            />
            <h4>{t("queryStock")}</h4>
          </Grid>
        </Grid>
      </Grid>

      {loadingFilters ? (
        <Grid
          item
          xs={11}
          sx={{ display: "flex", alignItems: "center", height: "50px" }}
          className={s.loaderGames}
        >
          <CircularProgress sx={{ mr: 3 }} />
          {t("loadingFilter")}
        </Grid>
      ) : (
        <>
          <FiltersStock
            searching={searching}
            handleSearch={handleSearch}
            handleCleanFilters={handleCleanFilters}
            dateType={dateType}
            setDateType={setDateType}
            filters={filters}
            setFilters={setFilters}
            setLoadingFilters={setLoadingFilters}
            games={games}
            setGames={setGames}
            handleCleanTable={handleCleanTable}
          />
          <Grid item xs={11} className={s.options}>
            <Grid item xs={6}>
              {loading ? (
                <CircularProgress size="1.2rem" />
              ) : (
                <p
                  style={{ fontSize: "1.2rem", margin: 0 }}
                >{`${t("results")}: ${totalResults}`}</p>
              )}
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                size="small"
                onClick={() => setPrinting(true)}
                variant="contained"
                sx={{ ml: 1 }}
              >
                <LocalPrintshopRoundedIcon
                  color={textColor}
                  sx={{ fontSize: "30px" }}
                />
                <p>{t("print")}</p>
              </Button>
              <Button
                size="small"
                onClick={() => handleExport()}
                variant="contained"
                sx={{ ml: 1 }}
              >
                <DescriptionIcon color={textColor} sx={{ fontSize: "30px" }} />
                <p>Excel</p>
              </Button>
            </Grid>
          </Grid>
        </>
      )}

      {loading ? (
        <Grid item xs={12} className={s.loader}>
          <CircularProgress size={"4rem"} />
        </Grid>
      ) : (
        <Grid item container xs={11} className={s.data} id="stock-table">
          {printing !== true ? (
            <></>
          ) : (
            <div className="logo">
              <img className={s.headerLogo} src={logo} alt="logo" />
            </div>
          )}
          {printing !== true ? (
            items?.length && filters.type && filters.type !== 0 ? (
              filters.type === 1 ? (
                <TableStockPrePrinted
                  items={items}
                  dateType={dateType}
                  filters={filters}
                  sort={sort}
                  handleSort={handleSort}
                  t={t}
                  textColor={textColor}
                  cellStyles={cellStyles}
                />
              ) : filters.type === 2 ? (
                <TableStockInstantaneous
                  items={items}
                  dateType={dateType}
                  filterw={filters}
                  t={t}
                  sort={sort}
                  handleSort={handleSort}
                  textColor={textColor}
                  cellStyles={cellStyles}
                />
              ) : (
                <></>
              )
            ) : (
              <Grid
                item
                xs={12}
                sx={{
                  minHeight: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "1.8rem",
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: 300,
                }}
              >
                {t("doASearch")}
              </Grid>
            )
          ) : completeReport?.length && filters.type && filters.type !== 0 ? (
            filters.type === 1 ? (
              <TableStockPrePrinted
                items={completeReport}
                dateType={dateType}
                filters={filters}
                sort={sort}
                handleSort={handleSort}
                t={t}
                textColor={textColor}
                cellStyles={cellStyles}
              />
            ) : filters.type === 2 ? (
              <TableStockInstantaneous
                items={completeReport}
                dateType={dateType}
                filterw={filters}
                t={t}
                sort={sort}
                handleSort={handleSort}
                textColor={textColor}
                cellStyles={cellStyles}
              />
            ) : (
              <></>
            )
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                minHeight: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "1.8rem",
                fontFamily: "Roboto, sans-serif",
                fontWeight: 300,
              }}
            >
              {t("doASearch")}
            </Grid>
          )}
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: "50px",
        }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
      <Snackbar
        open={noResult}
        autoHideDuration={6000}
        onClose={() => setNoResult(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setNoResult(false)}
          severity="info"
          sx={{ width: "100%" }}
        >
          {t("noResults")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};
